.card {
  background-color: var(--colors-grays-white);
  border-radius: 24px;
  box-shadow: var(--shadows-hard);
  max-width: calc(100vw - 32px);
  padding: 24px;
  width: 500px;
}

.sheetBody {
  padding: 16px 16px 24px;
}

.close {
  flex-shrink: 0;
  margin: -8px -8px 0 0;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.product {
  align-items: center;
  border: 1px solid var(--colors-grays-light);
  border-radius: var(--border-radius-lg);
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding: 16px;
  position: relative;
}

.product:has(.reviewButton:hover) {
  background-color: var(--colors-grays-ultralight);
}

.reviewButton {
  background: none;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
}

.reviewButton::after {
  border-radius: var(--border-radius-lg);
  content: '';
  inset: 0;
  position: absolute;
}

.reviewButton:focus-visible {
  outline: none;
}

.reviewButton:focus-visible::after {
  outline: 2px solid var(--colors-primary-main);
  outline-offset: 2px;
}

.chevron {
  align-items: center;
  background-color: var(--colors-grays-ultralight);
  border-radius: 50%;
  display: flex;
  height: 40px;
  justify-content: center;
  width: 40px;
}
